import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './auth.reducer.js';
import { messageReducer } from './message.reducer.js';

const store = configureStore({
  reducer: {
    authReducer: authReducer,
    messageReducer: messageReducer
  },
});

export default store;
